import { commons } from "@/services/requests";
import { useRouter } from "next/router";
import { useMutation, useQueryClient } from "react-query";

export default function useFavorite() {
  const queryClient = useQueryClient();

  const { pathname } = useRouter();

  const {
    mutate: addFavorite,
    isLoading: isLoadingAddFavorite,
    isSuccess: isSuccessAddFavorite,
  } = useMutation((id: number) => commons.postAddFavorite(id), {
    onSuccess: () => {
      queryClient.invalidateQueries(["PRODUCT"]);
    },
  });

  const {
    mutate: deleteFavorite,
    isLoading: isLoadingDeleteFavorite,
    isSuccess: isSuccessDeleteFavorite,
  } = useMutation((id: number) => commons.postDeleteFavorite(id), {
    onSuccess: () => {
      if (pathname === "/favorite") {
        queryClient.invalidateQueries(["WISHLIST"]);
      }

      queryClient.invalidateQueries(["PRODUCT"]);
    },
  });

  return {
    addFavorite,
    isLoadingAddFavorite,
    isSuccessAddFavorite,
    deleteFavorite,
    isLoadingDeleteFavorite,
    isSuccessDeleteFavorite,
  };
}
